import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { config } from '../../shared/config';

@Injectable({
  providedIn: 'root'
})
export class PasswordService {

  constructor(private http: HttpClient) { }

  // setup(email: string, code: string, password: string): Observable<void> {
  //   // never send password over HTTP GET!
  //   return this.http.post<any>(`${config.apiUrl}/setup`, { email, code, password });
  // }

  requestRecovery(emailAddress: string) {
    return this.http.post<any>(`${config.apiUrl}/Login/SendPasswordResetLink`, { emailAddress });
  }

  recover(emailAddress: string, passwordResetToken: string, password: string, confirmPassword: string): Observable<void> {
    // never send password over HTTP GET!
    return this.http.post<any>(`${config.apiUrl}/Login/ResetPassword`,  { emailAddress, passwordResetToken, password, confirmPassword });
  }
}
